import axios from 'axios';

// Създаване на API инстанция използвайки прокси вместо директен достъп до WooCommerce API
const apiClient = axios.create({
  baseURL: '/api', // Използване на променлива от средата или по подразбиране /api
  headers: {
    'Content-Type': 'application/json'
  }
});

// ===== API УСЛУГИ =====

// API за продукти
export const ProductsAPI = {
  // Вземане на всички продукти
  getProducts: async (page = 1, perPage = 10, additionalParams = {}) => {
    try {
      const response = await apiClient.get('/items', {
        params: { 
          page,
          per_page: perPage,
          ...additionalParams
        }
      });
      return response.data;
    } catch (error) {
      console.error('Грешка при извличане на продукти:', error);
      throw error;
    }
  },
  
  // Вземане на един продукт
  getProduct: async (productId) => {
    try {
      const response = await apiClient.get(`/items/${productId}`);
      return response.data;
    } catch (error) {
      console.error(`Грешка при извличане на продукт ${productId}:`, error);
      throw error;
    }
  }
};

// API за плащания
export const PaymentAPI = {
  // Вземане на налични методи за плащане
  getPaymentGateways: async () => {
    try {
      const response = await apiClient.get('/payments');
      return response.data;
    } catch (error) {
      console.error('Грешка при извличане на методи за плащане:', error);
      throw error;
    }
  }
};

// API за доставка
export const ShippingAPI = {
  // Вземане на зони за доставка
  getShippingZones: async () => {
    try {
      const response = await apiClient.get('/delivery/regions');
      return response.data;
    } catch (error) {
      console.error('Грешка при извличане на зони за доставка:', error);
      throw error;
    }
  },
  
  // Вземане на методи за доставка за конкретна зона
  getShippingMethods: async (zoneId) => {
    try {
      const response = await apiClient.get(`/delivery/regions/${zoneId}/options`);
      return response.data;
    } catch (error) {
      console.error(`Грешка при извличане на методи за доставка за зона ${zoneId}:`, error);
      throw error;
    }
  },
  
  // Изчисляване на доставка за кошницата
  calculateShipping: async (cartItems, shippingAddress = {}) => {
    try {
      const response = await apiClient.post('/delivery/calculate', {
        items: cartItems,
        shipping_address: shippingAddress
      });
      
      return response.data;
    } catch (error) {
      console.error('Грешка при изчисляване на доставката:', error);
      throw error;
    }
  }
};

// API за купони
export const CouponAPI = {
  // Валидиране на код за купон
  validateCoupon: async (code, items, email = null) => {
    try {
      const response = await apiClient.post('/coupons/validate', {
        code,
        items,
        customer_email: email
      });
      return response.data;
    } catch (error) {
      console.error('Грешка при валидиране на купон:', error);
      throw error;
    }
  },
  
  // Вземане на купон по код
  getCouponByCode: async (code) => {
    try {
      const response = await apiClient.get(`/coupons/code/${code}`);
      return response.data;
    } catch (error) {
      console.error('Грешка при извличане на купон:', error);
      throw error;
    }
  }
};

// API за поръчки
export const OrdersAPI = {
  // Създаване на нова поръчка
  createOrder: async (orderData) => {
    try {
      const response = await apiClient.post('/checkout', orderData);
      return response.data;
    } catch (error) {
      console.error('Грешка при създаване на поръчка:', error);
      throw error;
    }
  }
};

// Създаване на именован обект за експорт
const apiServices = {
  ProductsAPI,
  PaymentAPI,
  ShippingAPI,
  CouponAPI,
  OrdersAPI
};

export default apiServices; 